
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class AiBuilderStep extends Vue {
  @Prop({ type: Number, default: 0 }) current!: number; //当前步骤
  stepList = ["考察项配置", "其他配置"];

  mounted() {
    //todo
  }
}
